<template>
  <b-container>
    <h3>Entschuldigung:</h3>
    <div style="padding-top: 15px;">
      <b-table-simple>
        <b-tbody>
          <b-tr>
            <b-th>Eltern</b-th>
            <b-td>{{ excuse.parent_name }}</b-td>
          </b-tr>
          <b-tr>
            <b-th>Kind</b-th>
            <b-td>{{ excuse.child_name }}</b-td>
          </b-tr>
          <b-tr>
            <b-th>Klasse</b-th>
            <b-td>{{ excuse.grade }} {{ excuse.grade_specification.toUpperCase() }}</b-td>
          </b-tr>
          <b-tr>
            <b-th>von</b-th>
            <b-td>{{ excuse.start }}</b-td>
          </b-tr>
          <b-tr>
            <b-th>bis</b-th>
            <b-td>{{ excuse.end }}</b-td>
          </b-tr>
          <b-tr>
            <b-th>Email</b-th>
            <b-td>{{ excuse.email }}</b-td>
          </b-tr>
          <b-tr>
            <b-th>Bemerkung</b-th>
            <b-td>{{ excuse.description }}</b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </b-container>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

export default {
  name: "ViewExcuse",
  data() {
    return {
      excuseId: parseInt(this.$route.params.excuseId)
    }
  },
  computed: {
    ...mapGetters([
      'getStoredExcuseById'
    ]),
    excuse() {
      return this.getStoredExcuseById(this.excuseId)
    }
  },
  mounted() {
    this.getExcuseById(this.excuseId)
  },
  methods: {
    ...mapActions([
      'getExcuseById'
    ])
  }
}
</script>

<style scoped>
</style>
